export const COMPONENT_KEY_VALUE_BY_TYPE = {
  text: 'textValue',
  select: 'selectValue',
  listSelect: 'selectValue',
  tag: 'tagValue',
  number: 'numberValue',
  toggle: 'booleanValue',
  date: 'dateValue',
  photo: 'photoValue',
  signature: 'signatureValue',
};
